import React from "react";
import { css } from "emotion";
import PageTemplate from "../../components/PageTemplate";
import PermissionsMobileHeader from "../../components/Settings/PermissionsMobileHeader";
import { boxStyles } from "../../styles/theme";
import PermissionsBody from "../../components/Settings/PermissionsBody";
import TitleWithBackButton from "../../components/TitleWithBackButton";

const Permissions = () => {
  return (
    <PageTemplate
      title="Permissions"
      mobileHeader={<PermissionsMobileHeader />}
      sidebarTitle="Permissions"
      sidebarSubtitle={"Set permissions for this user"}
      centered
    >
      <div className={container}>
        <div className="desktop-only">
          <TitleWithBackButton
            title="Select Role"
            backLocation={"settings/users"}
          />
        </div>
        <PermissionsBody />
      </div>
    </PageTemplate>
  );
};

export default Permissions;

const container = css`
  .desktop-only {
    display: none;
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop-only {
      display: block;
      padding: ${boxStyles.standardPadding};
    }
  }
`;
